import { render } from "./IconMenu.vue?vue&type=template&id=7da47706"
import script from "./IconMenu.vue?vue&type=script&lang=js"
export * from "./IconMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7da47706"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7da47706', __exports__)) {
    api.reload('7da47706', __exports__)
  }
  
  module.hot.accept("./IconMenu.vue?vue&type=template&id=7da47706", () => {
    api.rerender('7da47706', render)
  })

}


export default __exports__